export default __webpack_public_path__ + "static/media/lock.358abf73.svg";